import {IDropdownObject} from './dropdown-object.interface';
import {IContactPerson} from './personal-data.interface';

export interface ILongTermLeaveDialog extends ISabbatical, IMobilization {
  createdByOptionList: IDropdownObject[];
}

export interface ISabbatical {
  comment: string;
  startDate: string;
  endDate?: string;
  type: LongTermLeaveType;
  employeeId: number;
  id: number;
  vacationDecision?: number;
  paymentDate?: string;
}

export interface IMobilization {
  type: LongTermLeaveType;
  id: number;
  employeeId: number;
  startDate: string;
  endDate?: string;
  createdBy: IDropdownObject;
  corporateAccount: IDropdownObject;
  accountCorrespondence: IDropdownObject;
  equipment: IDropdownObject;
  emergencyContactPerson: IContactPerson | null;
  comment: string;
}

export interface ILongTermLeaveDropdowns {
  Type: IDropdownObject[];
  AccountBlockOption: IDropdownObject[];
  EquipmentOption: IDropdownObject[];
  Relationship: IDropdownObject[];
  AccountCorrespondenceOption: IDropdownObject[];
}

export interface ILongTermLeaveResponse {
  mobilizationPeriodId: number;
  contactPersonId: number;
}

export enum LongTermLeaveType {
  Sabbatical = 1,
  Mobilization,
}
